module.exports = {"330205001":"外滩街道","330205003":"孔浦街道","330205004":"文教街道","330205005":"甬江街道","330205006":"庄桥街道","330205007":"洪塘街道","330205008":"前江街道","330205103":"慈城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330205.json
// module id = 1059
// module chunks = 0